
export function locToString(loc) {
  return `${loc.start.line}:${loc.start.column}`;
}